(ns cljsjs.amazon-cognito-identity-js
  (:require ["amazon-cognito-identity-js" :as amazon-cognito-identity-js]))

(js/goog.exportSymbol "AmazonCognitoIdentity" amazon-cognito-identity-js)
